"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _BaseButton = _interopRequireDefault(require("./BaseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const colorProfile = {
  contained: {
    primary: {
      backgroundColor: _BaseTheme.default.colors.green,
      color: _BaseTheme.default.colors.white,
      borderColor: _BaseTheme.default.colors.green,
      hoverColor: '#1aa812'
    },
    error: {
      backgroundColor: _BaseTheme.default.colors.red,
      color: _BaseTheme.default.colors.white,
      borderColor: _BaseTheme.default.colors.red,
      hoverColor: '#D21D13'
    }
  },
  outlined: {
    primary: {
      backgroundColor: _BaseTheme.default.colors.white,
      color: _BaseTheme.default.colors.green,
      borderColor: _BaseTheme.default.colors.green,
      hoverColor: '#1aa812'
    },
    error: {
      backgroundColor: _BaseTheme.default.colors.white,
      color: _BaseTheme.default.colors.red,
      borderColor: _BaseTheme.default.colors.red,
      hoverColor: '#D21D13'
    },
    white: {
      backgroundColor: 'none',
      color: _BaseTheme.default.colors.white,
      borderColor: _BaseTheme.default.colors.white,
      hoverColor: '#1aa812'
    }
  },
  text: {
    primary: {
      backgroundColor: 'none',
      color: _BaseTheme.default.colors.blue,
      borderColor: _BaseTheme.default.colors.white,
      hoverColor: _BaseTheme.default.colors.blue
    }
  }
};

const ButtonStyled = _styledComponents.default.button.withConfig({
  displayName: "Button__ButtonStyled",
  componentId: "design-system__sc-1eahpyb-0"
})(["", ";background-color:", ";border-color:", ";color:", ";font-weight:", ";&:hover{color:", ";border-color:", ";}&:disabled{background-color:", ";border-color:", ";color:", ";}"], _BaseButton.default, _ref => {
  let {
    profile
  } = _ref;
  return profile.backgroundColor;
}, _ref2 => {
  let {
    profile
  } = _ref2;
  return profile.borderColor;
}, _ref3 => {
  let {
    profile
  } = _ref3;
  return profile.color;
}, _BaseTheme.default.type.weight.bold, _ref4 => {
  let {
    profile
  } = _ref4;
  return profile.color;
}, _ref5 => {
  let {
    profile
  } = _ref5;
  return profile.hoverColor;
}, _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.white);

const Button = _ref6 => {
  let {
    children,
    type,
    onClick,
    disabled,
    profile,
    submit,
    url
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["children", "type", "onClick", "disabled", "profile", "submit", "url"]);

  if (url) {
    return /*#__PURE__*/_react.default.createElement(ButtonStyled, _extends({
      as: _reactRouterDom.Link,
      to: url,
      profile: colorProfile[type][profile]
    }, props), children);
  }

  return /*#__PURE__*/_react.default.createElement(ButtonStyled, _extends({
    role: "button",
    type: submit ? 'submit' : 'button',
    profile: colorProfile[type][profile],
    disabled: disabled,
    onClick: disabled ? () => {} : onClick
  }, props), children);
};

Button.propTypes = {
  children: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['contained', 'outlined', 'text']),
  profile: _propTypes.default.oneOf(['primary', 'error', 'white']),
  submit: _propTypes.default.bool,
  url: _propTypes.default.string
};
Button.defaultProps = {
  onClick: undefined,
  disabled: undefined,
  type: 'contained',
  profile: 'primary',
  submit: false,
  url: undefined
};
var _default = Button;
exports.default = _default;